import { useContext } from 'react';

import { ImxImrSeasonStateContext } from './ImxImrSeasonContextProvider';

import ImxImrSeasonData from './ImxImrSeasonData';

const useImxImrSeasonData = () => {
  const [imxImrSeasonState, setImxImrSeasonState] = useContext(ImxImrSeasonStateContext);

  const getImxImrSeasons = () => ImxImrSeasonData.getImxImrSeasonData(imxImrSeasonState, setImxImrSeasonState);

  return {
    imxImrSeasonState,
    getImxImrSeasons
  };
};

export default useImxImrSeasonData;